<template>
  <div class="toufang-game-permission">
    <div class="page-toolbar">
      <div>
        <h2>用户游戏权限</h2>
        <span>DY_Y4</span>
      </div>
      <el-button size="mini" icon="el-icon-refresh" @click="refreshPage">刷新</el-button>
    </div>

    <section v-if="canConfig" class="work-section">
      <div class="section-head">
        <h3>权限配置</h3>
        <el-tag size="mini" type="info">管理员</el-tag>
      </div>

      <el-form label-width="88px" size="mini" class="config-form">
        <el-form-item label="用户">
          <el-select
              v-model="selectedUserId"
              filterable
              clearable
              placeholder="选择用户"
              style="width: 280px"
              @change="loadUserConfig">
            <el-option
                v-for="user in users"
                :key="user.id"
                :label="user.username"
                :value="user.id">
              <span>{{ user.username }}</span>
              <span class="option-extra">ID {{ user.id }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="全部游戏">
          <el-switch v-model="formAllGame" :disabled="!selectedUserId"></el-switch>
        </el-form-item>

        <el-form-item label="游戏">
          <el-select
              v-model="selectedGames"
              multiple
              collapse-tags
              filterable
              clearable
              :disabled="formAllGame || !selectedUserId"
              placeholder="选择可见游戏"
              style="width: 520px">
            <el-option
                v-for="game in games"
                :key="game"
                :label="game"
                :value="game">
            </el-option>
          </el-select>
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <div v-if="formAllGame">全部游戏</div>
              <div v-else>
                <div v-for="game in selectedGames" :key="game">{{ game }}</div>
              </div>
            </div>
            <el-tag class="count-tag" size="mini" type="success">已选 {{ formAllGame ? '全部' : selectedGames.length }}</el-tag>
          </el-tooltip>
        </el-form-item>

        <el-form-item>
          <el-button
              type="primary"
              icon="el-icon-check"
              :loading="saving"
              :disabled="!selectedUserId"
              @click="savePermission">
            保存
          </el-button>
          <el-button icon="el-icon-refresh-left" :disabled="!selectedUserId" @click="loadUserConfig(selectedUserId)">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <section class="work-section">
      <div class="section-head">
        <h3>授权数据</h3>
        <el-tag size="mini" :type="myAllGame ? 'success' : 'warning'">{{ myPermissionLabel }}</el-tag>
      </div>

      <div class="query-bar">
        <el-select
            v-model="queryGame"
            size="mini"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="游戏选择"
            style="width: 360px">
          <el-option
              v-for="game in myGames"
              :key="game"
              :label="game"
              :value="game">
          </el-option>
        </el-select>

        <el-date-picker
            v-model="dateRange"
            type="daterange"
            size="mini"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 260px">
        </el-date-picker>

        <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            :disabled="myGames.length === 0"
            :loading="dataLoading"
            @click="queryData">
          查询
        </el-button>
      </div>

      <el-alert
          v-if="myGames.length === 0"
          title="当前账号暂无可见游戏"
          type="warning"
          :closable="false"
          show-icon>
      </el-alert>

      <el-table
          v-loading="dataLoading"
          :data="tableData"
          size="mini"
          stripe
          height="58vh"
          class="data-table"
          :row-class-name="tableRowClassName"
          :header-cell-style="{background:'rgba(244,244,245,0)', color:'#323335'}">
        <el-table-column prop="uploadDate" label="日期" min-width="130" sortable></el-table-column>
        <el-table-column prop="gameTypeConfig.gameType" label="品类" min-width="80"></el-table-column>
        <el-table-column prop="gameName" label="游戏名称" min-width="150" show-tooltip-when-overflow>
          <template slot-scope="{row}">
            <span class="game-name" :class="row.isSummary ? 'summary-name' : ''">{{ row.gameName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statCost" label="消耗" min-width="100">
          <template slot-scope="{row}">
            {{ row.statCost | dataFilters2 }}
          </template>
        </el-table-column>
        <el-table-column prop="estimatedProfit" label="预估利润" min-width="100">
          <template slot-scope="{row}">
            <span :class="estimatedProfit(row) > 0 ? 'red' : 'green'">
              {{ estimatedProfit(row).toFixed(2) }}
            </span>
          </template>
        </el-table-column>
<!--        <el-table-column prop="roi3" label="预估ROI|倍率" min-width="110">-->
<!--          <template slot-scope="{row}">-->
<!--            <span class="yugu2">{{ maxRoiPercent(row) }}</span>-->
<!--            <span>|</span>-->
<!--            <span class="yugu">{{ maxRoiValue(row) | dataFilters2 }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="maxNonZeroDay" label="预估周期" min-width="80">
          <template slot-scope="{row}">
            {{ getMaxNonZeroDay(row) }}
          </template>
        </el-table-column>

        <el-table-column
            v-for="day in fixedRoiDays"
            :key="'fixed-' + day"
            :prop="'roi' + day"
            :label="day + '日ROI'"
            min-width="120">
          <template slot-scope="{row}">
            <span v-show="checkedCities2.includes('ROI')" :class="roiCellClass(row, day)">
              {{ roiPercent(row, day) }}
            </span>
            <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>
            <span v-show="checkedCities2.includes('倍率')" :class="rateCellClass(row, day)">
              {{ roiValue(row, day) | dataFilters2 }}
            </span>
            <i
                v-if="hasRepairedColumn(row, 'roi' + day)"
                class="el-icon-star-on updated-marker-icon"
                title="根据品类分组预估">
            </i>
          </template>
        </el-table-column>

        <el-table-column
            v-for="day in roiDays"
            :key="'roi-' + day"
            :prop="'roi' + day"
            :label="day + '日ROI'"
            min-width="150">
          <template slot-scope="{row}">
            <span v-show="checkedCities2.includes('ROI')" :class="roiCellClass(row, day)">
              {{ roiPercent(row, day) }}
            </span>
            <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>
            <span v-show="checkedCities2.includes('倍率')" :class="rateCellClass(row, day)">
              {{ roiValue(row, day) | dataFilters2 }}
            </span>
            <i
                v-if="hasRepairedColumn(row, 'roi' + day)"
                class="el-icon-star-on updated-marker-icon"
                title="根据品类分组预估">
            </i>
          </template>
        </el-table-column>

        <el-table-column prop="groupLabel" label="标签" min-width="150" show-tooltip-when-overflow></el-table-column>
      </el-table>

      <el-pagination
          class="data-total"
          layout="total"
          :total="tableData.length">
      </el-pagination>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ToufangGamePermission',
  data() {
    return {
      canConfig: false,
      users: [],
      games: [],
      selectedUserId: null,
      formAllGame: false,
      selectedGames: [],
      saving: false,
      myAllGame: false,
      myGames: [],
      queryGame: [],
      dateRange: [],
      tableData: [],
      dataLoading: false,
      checkedCities2: ['ROI', '倍率'],
      fixedRoiDays: [1, 2,3, 4, 5, 6],
      roiDays: [ 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150]
    }
  },
  computed: {
    myPermissionLabel() {
      return this.myAllGame ? '全部游戏' : this.myGames.length + ' 个游戏'
    }
  },
  filters: {
    dataFilters2(value) {
      const numberValue = Number(value)
      if (!numberValue || Number.isNaN(numberValue)) {
        return '-'
      }
      return numberValue.toFixed(2)
    }
  },
  mounted() {
    this.setDefaultDateRange()
    this.loadMyGames()
    this.loadConfigBase()
  },
  methods: {
    refreshPage() {
      this.loadMyGames()
      this.loadConfigBase()
      if (this.myGames.length > 0) {
        this.queryData()
      }
    },
    setDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 7)
      this.dateRange = [this.formatDate(start), this.formatDate(end)]
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    async loadConfigBase() {
      try {
        const [usersResponse, gamesResponse] = await Promise.all([
          this.$axios.get('/toufang/gamePermission/users'),
          this.$axios.get('/toufang/gamePermission/games')
        ])

        if (!usersResponse.data.success || !gamesResponse.data.success) {
          this.canConfig = false
          return
        }

        this.users = usersResponse.data.data || []
        this.games = gamesResponse.data.data || []
        this.canConfig = true
      } catch (error) {
        this.canConfig = false
      }
    },
    async loadUserConfig(userId) {
      if (!userId) {
        this.formAllGame = false
        this.selectedGames = []
        return
      }

      try {
        const response = await this.$axios.get(`/toufang/gamePermission/user/${userId}`)
        const data = response.data.data || {}
        this.formAllGame = !!data.allGame
        this.selectedGames = data.gameNames || []
      } catch (error) {
        this.$message.error('加载配置失败')
      }
    },
    async savePermission() {
      if (!this.selectedUserId) {
        return
      }

      this.saving = true
      try {
        const response = await this.$axios.post('/toufang/gamePermission/save', {
          userId: this.selectedUserId,
          allGame: this.formAllGame,
          gameNames: this.formAllGame ? [] : this.selectedGames
        })

        if (response.data.success) {
          this.$message.success('保存成功')
          await this.loadUserConfig(this.selectedUserId)
        } else {
          this.$message.error(response.data.msg || '保存失败')
        }
      } catch (error) {
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },
    async loadMyGames() {
      try {
        const response = await this.$axios.get('/toufang/gamePermission/myGames')
        const data = response.data.data || {}
        this.myAllGame = !!data.allGame
        this.myGames = data.games || []

        if (Array.isArray(this.queryGame) && this.queryGame.length > 0) {
          this.queryGame = this.queryGame.filter(game => this.myGames.includes(game))
        }
      } catch (error) {
        this.myAllGame = false
        this.myGames = []
      }
    },
    async queryData() {
      this.dataLoading = true
      try {
        const response = await this.$axios.post('/toufang/data/findY4ByPermission', {
          cname: '',
          gameNames: this.selectedQueryGames(),
          start: this.dateRange && this.dateRange.length > 0 ? this.dateRange[0] : '',
          end: this.dateRange && this.dateRange.length > 1 ? this.dateRange[1] : '',
          currentPage: 1,
          date: '',
          type: ''
        })

        if (response.data.success) {
          this.tableData = this.withSummaryRow(response.data.data || [])
        } else {
          this.tableData = []
          this.$message.error(response.data.msg || '查询失败')
        }
      } catch (error) {
        this.tableData = []
        this.$message.error('查询失败')
      } finally {
        this.dataLoading = false
      }
    },
    tableRowClassName({ row }) {
      const classes = [row && row.isSummary ? 'summary-row' : 'date-total-row2']
      if (this.isY4ActualData(row)) {
        classes.push('y4-actual-row')
      }
      return classes.join(' ')
    },
    isY4ActualData(row) {
      if (!row) {
        return false
      }
      const source = row.dataSource || row.datasource || row.data_source
      return source === '真实'
    },
    roiDaySource(row, day) {
      if (!row) {
        return ''
      }
      const keys = [
        'roi' + day + 'Source',
        'roi' + day + '_source',
        'roi_' + day + '_source'
      ]
      for (const key of keys) {
        if (row[key] !== undefined && row[key] !== null && row[key] !== '') {
          return String(row[key])
        }
      }
      return ''
    },
    isActualSource(source) {
      if (!source) {
        return false
      }
      const value = String(source).toLowerCase()
      return source === '真实' || value === 'actual' || value === 'real'
    },
    isEstimatedSource(source) {
      if (!source) {
        return false
      }
      const value = String(source).toLowerCase()
      return source === '预估' || source === '混合' || ['estimated', 'estimate', 'mixed', 'fit'].includes(value)
    },
    roiCellHasActualValue(row, day) {
      return this.toNumber(row && row['roi' + day]) > 0
    },
    parseUploadDate(row) {
      if (!row) {
        return null
      }
      const text = String(row.uploadDate || row.upload_date || row.statTimeDay || row.stat_time_day || row.date || '').slice(0, 10)
      const parts = text.split(/[-/]/).map(item => Number(item))
      if (parts.length < 3 || parts.some(item => !Number.isFinite(item))) {
        return null
      }
      const parsed = new Date(parts[0], parts[1] - 1, parts[2])
      if (Number.isNaN(parsed.getTime())) {
        return null
      }
      parsed.setHours(0, 0, 0, 0)
      return parsed
    },
    isDescTypeWindow(row) {
      const uploadDate = this.parseUploadDate(row)
      if (!uploadDate) {
        return true
      }
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const diffDays = Math.floor((today.getTime() - uploadDate.getTime()) / 86400000)
      return diffDays <= 150
    },
    isEstimatedRoiCell(row, day) {
      if (!row || row.isSummary) {
        return false
      }
      if (!this.isDescTypeWindow(row)) {
        return false
      }
      return this.descType(row) <= day
    },
    roiCellClass(row, day) {
      return this.isEstimatedRoiCell(row, day) ? 'yugu2' : 'y4-real-value'
    },
    rateCellClass(row, day) {
      return this.isEstimatedRoiCell(row, day) ? 'yugu' : 'y4-real-value'
    },
    toNumber(value) {
      const numberValue = Number(value)
      return Number.isNaN(numberValue) ? 0 : numberValue
    },
    descType(row) {
      return this.toNumber(row.descType)
    },
    roiValue(row, day) {
      return this.toNumber(row['roi' + day])
    },
    roiPercent(row, day) {
      return (this.roiValue(row, day) * this.toNumber(row.roi0) * 100).toFixed(2) + '%'
    },
    maxRoiValue(row) {
      const values = this.roiDays.map(day => this.roiValue(row, day))
      return Math.max(...values)
    },
    maxRoiPercent(row) {
      return (this.maxRoiValue(row) * this.toNumber(row.roi0) * 100).toFixed(2) + '%'
    },
    estimatedProfit(row) {
      const statCost = this.toNumber(row.statCost)
      const pfAmount = this.toNumber(row.pfAmount)
      return (this.maxRoiValue(row) * this.toNumber(row.roi0) - 1) * (statCost - pfAmount)
    },
    getMaxNonZeroDay(row) {
      for (let i = this.roiDays.length - 1; i >= 0; i--) {
        const day = this.roiDays[i]
        if (this.roiValue(row, day) !== 0) {
          return day
        }
      }
      return '-'
    },
    hasRepairedColumn(row, prop) {
      return row.repairedColumns &&
          typeof row.repairedColumns === 'string' &&
          (',' + row.repairedColumns + ',').includes(',' + prop + ',')
    },
    selectedQueryGames() {
      return Array.isArray(this.queryGame) ? this.queryGame.filter(Boolean) : []
    },
    withSummaryRow(rows) {
      if (!Array.isArray(rows) || rows.length === 0) {
        return rows
      }
      return [this.buildSummaryRow(rows), ...rows]
    },
    buildSummaryRow(rows) {
      const allDays = [...this.fixedRoiDays, ...this.roiDays]
      const totalCost = rows.reduce((sum, row) => sum + this.toNumber(row.statCost), 0)
      const totalPfAmount = rows.reduce((sum, row) => sum + this.toNumber(row.pfAmount), 0)
      const totalBaseIncome = rows.reduce((sum, row) => {
        return sum + this.toNumber(row.statCost) * this.toNumber(row.roi0)
      }, 0)
      const summary = {
        isSummary: true,
        uploadDate: '汇总',
        gameTypeConfig: { gameType: '汇总' },
        gameName: this.summaryGameName(rows),
        statCost: totalCost,
        pfAmount: totalPfAmount,
        roi0: totalCost > 0 ? totalBaseIncome / totalCost : 0,
        descType: 999,
        groupLabel: '汇总'
      }
      allDays.forEach(day => {
        const totalIncome = rows.reduce((sum, row) => {
          return sum + this.toNumber(row.statCost) * this.toNumber(row.roi0) * this.toNumber(row['roi' + day])
        }, 0)
        summary['roi' + day] = totalBaseIncome > 0 ? totalIncome / totalBaseIncome : 0
      })
      return summary
    },
    summaryGameName(rows) {
      const selectedGames = this.selectedQueryGames()
      if (selectedGames.length === 1) {
        return selectedGames[0] + ' 汇总'
      }
      if (selectedGames.length > 1) {
        return '多游戏汇总（' + selectedGames.length + '个游戏）'
      }
      const gameNames = [...new Set(rows.map(row => row.gameName).filter(Boolean))]
      if (gameNames.length === 1) {
        return gameNames[0] + ' 汇总'
      }
      return '多游戏汇总（' + gameNames.length + '个游戏）'
    }
  }
}
</script>

<style scoped>
.toufang-game-permission {
  min-height: 100vh;
  padding: 22px;
  background: #f6f8fb;
  color: #20242a;
  box-sizing: border-box;
}

.page-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.page-toolbar h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
}

.page-toolbar span {
  display: inline-block;
  margin-top: 4px;
  color: #70757d;
  font-size: 12px;
}

.work-section {
  padding: 16px;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid #dfe5ec;
  border-radius: 6px;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.section-head h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.config-form {
  max-width: 760px;
}

.option-extra {
  float: right;
  color: #9aa0a6;
  font-size: 12px;
}

.count-tag {
  margin-left: 8px;
}

.query-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.data-table {
  margin-top: 8px;
}

.data-total {
  margin-top: 8px;
}

.game-name {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.summary-name {
  font-weight: 600;
}

.data-table /deep/ .summary-row > td {
  background: #f4f8ff !important;
  font-weight: 600;
}

.yugu {
  color: #d65055;
  font-weight: 540;
}

.yugu2 {
  color: #3a8ee6;
  font-weight: 500;
}

.y4-real-value {
  color: #303133;
  font-weight: 400;
}

.data-table /deep/ .summary-row .cell span {
  color: #303133;
}

.red {
  color: #d65055;
}

.green {
  color: #5daf34;
}

.updated-marker-icon {
  color: #e39f0b;
  margin-left: 4px;
  font-size: 14px;
}

@media (max-width: 768px) {
  .toufang-game-permission {
    padding: 12px;
  }

  .page-toolbar {
    align-items: flex-start;
    gap: 10px;
  }

  .config-form /deep/ .el-select,
  .query-bar /deep/ .el-select,
  .query-bar /deep/ .el-date-editor {
    width: 100% !important;
  }
}
</style>
